import React from 'react';
import MeetingHeader from 'flow/components/meeting/MeetingHeader';
import MeetingVideoCanvas from 'flow/components/meeting/MeetingVideoCanvas';
import MeetingFooter from 'flow/components/meeting/MeetingFooter';

/**
 * The meeting screen for an unauthorized guest (joined by link, no Telavox
 * extension). It reuses the same fullscreen chrome as the authorized meeting:
 * MeetingHeader + MeetingVideoCanvas (which renders the error banner, the video
 * grid, the members list, and — for a non-member guest — the ephemeral chat) +
 * MeetingFooter. Each positions itself `fixed` in the fullscreen view a guest is
 * always in, so no container or sizing logic is needed here.
 *
 * The guest-specific differences live inside those shared components: the canvas
 * auto-selects VideoChatEphemeral for non-members, the footer forces its fixed
 * layout for guests, and the Add-participant button is gated on being logged in.
 */
const MeetingUnauthorized: React.FC = () => (
    <>
        <MeetingHeader />
        <MeetingVideoCanvas />
        <MeetingFooter />
    </>
);

export default MeetingUnauthorized;
